import { PANEL } from "./panelTokens";

/** TopbarNotificationsMenu panel variant — theme token şekline uyumlu adapter */
export function getPanelNotificationColors() {
  return {
    primary: {
      400: PANEL.surface,
      500: PANEL.fill.muted,
      600: PANEL.pageBg,
      900: PANEL.text.primary,
    },
    blueAccent: {
      200: PANEL.blue.text,
      300: PANEL.blue.main,
      400: PANEL.blue.main,
      500: PANEL.blue.main,
      600: PANEL.blue.main,
      700: PANEL.border,
      800: PANEL.fill.muted,
      900: PANEL.pageBg,
    },
    greenAccent: {
      300: PANEL.accent.text,
      400: PANEL.accent.main,
      500: PANEL.accent.main,
      600: PANEL.accent.hover,
      700: PANEL.accent.text,
      800: PANEL.accent.soft12,
      900: PANEL.accent.soft,
    },
    grey: {
      100: PANEL.text.primary,
      200: PANEL.text.body,
      300: PANEL.text.muted,
      400: PANEL.text.label,
      700: PANEL.border,
    },
    redAccent: {
      300: "#f87171",
      500: PANEL.danger.main,
      600: PANEL.danger.text,
      700: PANEL.danger.main,
      900: PANEL.danger.soft,
    },
  };
}
